export enum ActionTypes {
  CreateUserPackage = 'createUserPackage',

  GetUserPackage = 'getUserPackage',
  GetUserPackageRequest = 'getUserPackage.request',
  GetUserPackageSuccess = 'getUserPackage.success',
  GetUserPackageFailure = 'getUserPackage.failure',
}
